export default {
	$accessibility: {
		archived: "Archiviert",
		present: "Anwesend",
	},
	$accessModifier: {
		$description: {
			hidden_from_receiver: "Vor dem Empfänger verborgen",
			hidden_from_sender: "Vor dem Absender verborgen",
			private: "Privat",
			shared_with_custom: "Mit benutzerdefinierten Personen geteilt",
			shared_with_everyone: "Mit allen geteilt",
			shared_with_receiver: "Mit dem Empfänger geteilt",
			shared_with_sender: "Mit dem Absender geteilt",
		},
	},
	$antProduct: {
		limitGBStorage: "{limit}GB Speicher",
		limitMBStorage: "{limit}MB Speicher",
		limitUser: "{limit} Benutzer",
		limitUsers: "{limit} Benutzer",
		renewAtPricePerUnit: "Wird bei {currency}{price} pro {unit} erneuert",
		unlimitedModule: "Unbegrenzte {module}",
		upToLimitModule: "Bis zu {limit} {module}",
	},
	$company: {
		address: "Kotekli Mah. Denizli Yolu Bul. Teknopark Sitesi B Blok No:4B Ic kapi No:14 MENTESE / MUGLA, TÜRKEI",
		googleMapSrc:
			"https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12715.523446137679!2d28.3731307!3d37.1793022!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bf732687fd3eb1%3A0x2815d6eefcce8910!2sMu%C4%9Fla%20Teknopark!5e0!3m2!1sen!2str!4v1701805110461!5m2!1sen!2str",
		name: "Slush Software Inc.",
		phoneNumber: "+90 (555) 444-33-22",
		slogan:
			"Beschleunigen Sie Ihr Geschäft mit Antrego. Verwalten Sie Ihre Versandprozesse digital, sicher und einfach.",
	},
	$cookieBanner: {
		accept: "Akzeptieren",
		decline: "Ablehnen",
		message:
			"Wir verwenden Cookies und ähnliche Technologien für Analysen und personalisierte Inhalte. Durch Klicken auf 'Akzeptieren' stimmen Sie der Nutzung dieser Technologien zu.",
	},
	$country: {
		afghanistan: "Afghanistan",
		aland: "Åland",
		albania: "Albanien",
		algeria: "Algerien",
		american_samoa: "Amerikanisch-Samoa",
		andorra: "Andorra",
		angola: "Angola",
		anguilla: "Anguilla",
		antarctica: "Antarktis",
		antigua_and_barbuda: "Antigua und Barbuda",
		argentina: "Argentinien",
		armenia: "Armenien",
		aruba: "Aruba",
		australia: "Australien",
		austria: "Österreich",
		azerbaijan: "Aserbaidschan",
		bahamas: "Bahamas",
		bahrain: "Bahrain",
		bangladesh: "Bangladesch",
		barbados: "Barbados",
		belarus: "Weißrussland",
		belgium: "Belgien",
		belize: "Belize",
		benin: "Benin",
		bermuda: "Bermuda",
		bhutan: "Bhutan",
		bolivia: "Bolivien",
		bonaire_sint_eustatius_and_saba: "Bonaire, Sint Eustatius und Saba",
		bosnia_and_herzegovina: "Bosnien und Herzegowina",
		botswana: "Botswana",
		bouvet_island: "Bouvetinsel",
		brazil: "Brasilien",
		british_indian_ocean_territory: "Britisches Territorium im Indischen Ozean",
		british_virgin_islands: "Britische Jungferninseln",
		brunei: "Brunei",
		bulgaria: "Bulgarien",
		burkina_faso: "Burkina Faso",
		burundi: "Burundi",
		cabo_verde: "Kap Verde",
		cambodia: "Kambodscha",
		cameroon: "Kamerun",
		canada: "Kanada",
		cayman_islands: "Kaimaninseln",
		central_african_republic: "Zentralafrikanische Republik",
		chad: "Tschad",
		chile: "Chile",
		china: "China",
		christmas_island: "Weihnachtsinsel",
		cocos_islands: "Kokosinseln",
		colombia: "Kolumbien",
		comoros: "Komoren",
		congo_republic: "Republik Kongo",
		cook_islands: "Cookinseln",
		costa_rica: "Costa Rica",
		croatia: "Kroatien",
		cuba: "Kuba",
		curacao: "Curaçao",
		cyprus: "Zypern",
		czechia: "Tschechien",
		denmark: "Dänemark",
		djibouti: "Dschibuti",
		dominica: "Dominica",
		dominican_republic: "Dominikanische Republik",
		dr_congo: "Demokratische Republik Kongo",
		ecuador: "Ecuador",
		egypt: "Ägypten",
		el_salvador: "El Salvador",
		equatorial_guinea: "Äquatorialguinea",
		eritrea: "Eritrea",
		estonia: "Estland",
		eswatini: "Eswatini",
		ethiopia: "Äthiopien",
		falkland_islands: "Falklandinseln",
		faroe_islands: "Färöer",
		fiji: "Fidschi",
		finland: "Finnland",
		france: "Frankreich",
		french_guiana: "Französisch-Guayana",
		french_polynesia: "Französisch-Polynesien",
		french_southern_territories: "Französische Süd- und Antarktisgebiete",
		gabon: "Gabun",
		gambia: "Gambia",
		georgia: "Georgien",
		germany: "Deutschland",
		ghana: "Ghana",
		gibraltar: "Gibraltar",
		greece: "Griechenland",
		greenland: "Grönland",
		grenada: "Grenada",
		guadeloupe: "Guadeloupe",
		guam: "Guam",
		guatemala: "Guatemala",
		guernsey: "Guernsey",
		guinea: "Guinea",
		guinea_bissau: "Guinea-Bissau",
		guyana: "Guyana",
		haiti: "Haiti",
		heard_island_and_mcdonald_islands: "Heard und McDonaldinseln",
		honduras: "Honduras",
		hong_kong: "Hongkong",
		hungary: "Ungarn",
		iceland: "Island",
		india: "Indien",
		indonesia: "Indonesien",
		iran: "Iran",
		iraq: "Irak",
		ireland: "Irland",
		isle_of_man: "Isle of Man",
		israel: "Israel",
		italy: "Italien",
		ivory_coast: "Elfenbeinküste",
		jamaica: "Jamaika",
		japan: "Japan",
		jersey: "Jersey",
		jordan: "Jordanien",
		kazakhstan: "Kasachstan",
		kenya: "Kenia",
		kiribati: "Kiribati",
		kosovo: "Kosovo",
		kuwait: "Kuwait",
		kyrgyzstan: "Kirgisistan",
		laos: "Laos",
		latvia: "Lettland",
		lebanon: "Libanon",
		lesotho: "Lesotho",
		liberia: "Liberia",
		libya: "Libyen",
		liechtenstein: "Liechtenstein",
		lithuania: "Litauen",
		luxembourg: "Luxemburg",
		macao: "Macao",
		madagascar: "Madagaskar",
		malawi: "Malawi",
		malaysia: "Malaysia",
		maldives: "Malediven",
		mali: "Mali",
		malta: "Malta",
		marshall_islands: "Marshallinseln",
		martinique: "Martinique",
		mauritania: "Mauretanien",
		mauritius: "Mauritius",
		mayotte: "Mayotte",
		mexico: "Mexiko",
		micronesia: "Mikronesien",
		moldova: "Moldawien",
		monaco: "Monaco",
		mongolia: "Mongolei",
		montenegro: "Montenegro",
		montserrat: "Montserrat",
		morocco: "Marokko",
		mozambique: "Mosambik",
		myanmar: "Myanmar",
		namibia: "Namibia",
		nauru: "Nauru",
		nepal: "Nepal",
		netherlands: "Niederlande",
		new_caledonia: "Neukaledonien",
		new_zealand: "Neuseeland",
		nicaragua: "Nicaragua",
		niger: "Niger",
		nigeria: "Nigeria",
		niue: "Niue",
		norfolk_island: "Norfolkinsel",
		north_korea: "Nordkorea",
		north_macedonia: "Nordmazedonien",
		northern_mariana_islands: "Nördliche Marianen",
		norway: "Norwegen",
		oman: "Oman",
		pakistan: "Pakistan",
		palau: "Palau",
		palestine: "Palästina",
		panama: "Panama",
		papua_new_guinea: "Papua-Neuguinea",
		paraguay: "Paraguay",
		peru: "Peru",
		philippines: "Philippinen",
		pitcairn_islands: "Pitcairninseln",
		poland: "Polen",
		portugal: "Portugal",
		puerto_rico: "Puerto Rico",
		qatar: "Katar",
		reunion: "Réunion",
		romania: "Rumänien",
		russia: "Russland",
		rwanda: "Ruanda",
		saint_barthelemy: "Saint Barthélemy",
		saint_helena: "St. Helena",
		saint_lucia: "St. Lucia",
		saint_martin: "Saint Martin",
		saint_pierre_and_miquelon: "Saint Pierre und Miquelon",
		samoa: "Samoa",
		san_marino: "San Marino",
		sao_tome_and_principe: "São Tomé und Príncipe",
		saudi_arabia: "Saudi-Arabien",
		senegal: "Senegal",
		serbia: "Serbien",
		seychelles: "Seychellen",
		sierra_leone: "Sierra Leone",
		singapore: "Singapur",
		sint_maarten: "Sint Maarten",
		slovakia: "Slowakei",
		slovenia: "Slowenien",
		solomon_islands: "Salomonen",
		somalia: "Somalia",
		south_africa: "Südafrika",
		south_georgia_and_south_sandwich_islands: "Südgeorgien und die Südlichen Sandwichinseln",
		south_korea: "Südkorea",
		south_sudan: "Südsudan",
		spain: "Spanien",
		sri_lanka: "Sri Lanka",
		st_kitts_and_nevis: "St. Kitts und Nevis",
		st_vincent_and_grenadines: "St. Vincent und die Grenadinen",
		sudan: "Sudan",
		suriname: "Suriname",
		svalbard_and_jan_mayen: "Spitzbergen und Jan Mayen",
		sweden: "Schweden",
		switzerland: "Schweiz",
		syria: "Syrien",
		taiwan: "Taiwan",
		tajikistan: "Tadschikistan",
		tanzania: "Tansania",
		thailand: "Thailand",
		timor_leste: "Osttimor",
		togo: "Togo",
		tokelau: "Tokelau",
		tonga: "Tonga",
		trinidad_and_tobago: "Trinidad und Tobago",
		tunisia: "Tunesien",
		turkiye: "Türkei",
		turkmenistan: "Turkmenistan",
		turks_and_caicos_islands: "Turks- und Caicosinseln",
		tuvalu: "Tuvalu",
		uganda: "Uganda",
		ukraine: "Ukraine",
		united_arab_emirates: "Vereinigte Arabische Emirate",
		united_kingdom: "Vereinigtes Königreich",
		united_states: "Vereinigte Staaten",
		uruguay: "Uruguay",
		us_minor_outlying_islands: "Amerikanische Außengebiete",
		us_virgin_islands: "Amerikanische Jungferninseln",
		uzbekistan: "Usbekistan",
		vanuatu: "Vanuatu",
		vatican_city: "Vatikanstadt",
		venezuela: "Venezuela",
		vietnam: "Vietnam",
		wallis_and_futuna: "Wallis und Futuna",
		western_sahara: "Westsahara",
		yemen: "Jemen",
		zambia: "Sambia",
		zimbabwe: "Simbabwe",
	},
	$currency: {
		euro: "Euro",
		turkish_lira: "Türkische Lira",
		us_dollar: "US-Dollar",
	},
	$documentManager: {
		message_1:
			'Um die Vorlage zu bearbeiten, klicken Sie auf die Schaltfläche "Vorlage bearbeiten", um zum Bearbeitungsbildschirm zu gelangen.',
		message_2:
			'Sie können die Anzahl der Zeilen in der Liste erhöhen oder verringern, indem Sie die "Zeilenanzahl" anpassen.',
		message_3: 'Änderungen, die Sie in den Inhaltsfeldern vornehmen, werden sofort in der "Vorschau" angezeigt.',
		message_4:
			'Um eine PDF zu erstellen, klicken Sie auf die Schaltfläche "Dokumentaktionen", um es als PDF zu speichern.',
		message_5:
			'Um später auf Dokumente zuzugreifen, können Sie diese über die Schaltfläche "Dokumentaktionen" speichern.',
		message_6: "Die in jede Tabellenzelle eingegebenen Daten werden in der Vorschau genau so angezeigt.",
		message_7: "Die Datentabelle kann wie eine Excel-Tabelle oder ein elektronisches Tabellenblatt bearbeitet werden.",
	},
	$employeeType: {
		admin: "Administrator",
		default: "Standard",
		exporter: "Exporteur",
		importer: "Importeur",
	},
	$format: {
		date: "DD.MM.YYYY",
		date_time: "DD.MM.YYYY HH:mm:ss",
		date_time_without_second: "DD.MM.YYYY HH:mm",
	},
	$home: {
		$noCompany: {
			create_company_subtitle: "Erstellen Sie hier Ihr Unternehmen.",
			create_company_title: "Möchten Sie Ihr Unternehmen hinzufügen?",
			description:
				"Sie haben sich erfolgreich angemeldet. Jetzt müssen Sie einem Unternehmen beitreten oder ein neues erstellen.",
			join_company_subtitle: "Geben Sie Ihren Code ein und treten Sie hier dem Unternehmen bei.",
			join_company_title: "Möchten Sie einem bestehenden Unternehmen beitreten?",
			title: "Willkommen {name}",
		},
		$unauthorized: {
			description: "Behalten Sie Ihre Export-Import-Prozesse mit Antrego im Griff",
			forget_password_subtitle: "Bitte geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen",
			sign_in_subtitle: "Hier anmelden",
			sign_in_title: "Haben Sie bereits ein Konto?",
			sign_up_subtitle: "Hier registrieren",
			sign_up_title: "Möchten Sie ein Konto erstellen?",
			title: "Willkommen bei Antrego",
		},
	},
	$invitationType: {
		company_partner: "Einladung zur kommerziellen Zusammenarbeit",
		customs_partner: "Einladung des Zollpartners",
		employee: "Mitarbeitereinladung",
	},
	$landing: {
		$benefits: {
			$detailPage: {
				hero_title: "Transformieren Sie Ihre Geschäftsabläufe",
				hero_subtitle: "Plattformvorteile",
				hero_description:
					"Entdecken Sie, wie Antrego Ihren gesamten Logistik-Workflow – vom Bestandsmanagement bis zur Sendungsverfolgung – verschlankt. Erleben Sie höhere Effizienz, geringere Kosten und bessere Zusammenarbeit in Ihrer Organisation.",
				features_title: "Umfassende Plattformvorteile",
				feature_1_title: "Zentrales Dashboard",
				feature_1_desc:
					"Greifen Sie über eine einzige, intuitive Oberfläche auf alle Logistikdaten, Sendungen, Bestände und Dokumente zu.",
				feature_2_title: "Höhere Datenqualität",
				feature_2_desc:
					"Minimieren Sie Fehler durch automatisierte Datenerfassung, Validierung und Echtzeit-Synchronisation über alle Module.",
				feature_3_title: "Zeitersparnis",
				feature_3_desc:
					"Sparen Sie täglich Stunden mit automatisierten Workflows, smarten Benachrichtigungen und schlanken Prozessen.",
				feature_4_title: "Teamzusammenarbeit",
				feature_4_desc:
					"Ermöglichen Sie nahtlose Zusammenarbeit zwischen internen Teams, Kunden, Lieferanten und Logistikpartnern.",
				feature_5_title: "Kostensenkung",
				feature_5_desc:
					"Reduzieren Sie Betriebskosten durch höhere Effizienz, weniger Fehler und optimierte Ressourcennutzung.",
				feature_6_title: "Skalierbarkeit",
				feature_6_desc: "Wachsen Sie souverän mit einer Plattform, die sich mühelos Ihren Anforderungen anpasst.",
				benefits_title: "Warum Antrego?",
				benefit_1: "Komplette Transparenz über die gesamte Lieferkette",
				benefit_2: "Sichere Cloud-Plattform mit Verschlüsselung auf Enterprise-Niveau",
				benefit_3: "Mobiloptimiertes Design für den Zugriff unterwegs",
				benefit_4: "Automatische Benachrichtigungen halten alle Beteiligten informiert",
				benefit_5: "Anpassbare Workflows, die sich Ihren Prozessen anpassen",
				benefit_6: "Engagiertes Support-Team für Ihren Erfolg",
				workflow_title: "Wie Antrego Ihre Abläufe transformiert",
				step_1_title: "Konsolidieren Sie Ihre Abläufe",
				step_1_desc:
					"Führen Sie Bestandsmanagement, Sendungsverfolgung, Dokumentenverwaltung und Kundenkommunikation in einer integrierten Plattform zusammen.",
				step_2_title: "Routineaufgaben automatisieren",
				step_2_desc:
					"Überlassen Sie Antrego repetitive Aufgaben wie Datenerfassung, Benachrichtigungen und Status-Updates – Ihr Team gewinnt Zeit für Strategie.",
				step_3_title: "Echtzeit-Zusammenarbeit ermöglichen",
				step_3_desc:
					"Teilen Sie Informationen sofort mit allen Beteiligten, damit jeder die neuesten Updates und Dokumente hat.",
				step_4_title: "Datengetriebene Entscheidungen treffen",
				step_4_desc:
					"Nutzen Sie umfassende Analysen und Reports, um Trends zu erkennen, Prozesse zu optimieren und kontinuierlich zu verbessern.",
				cta_title: "Bereit, Ihre Logistikabläufe zu transformieren?",
				cta_button: "Heute kostenlos starten",
				cta_subtitle: "Keine Kreditkarte erforderlich • Schließen Sie sich 500+ Unternehmen an",
			},
			benefits_title: "Plattformvorteile",
			business_process: "Beschleunigt Ihre Geschäftsprozesse.",
			control_title: "Übernehmen Sie die Kontrolle mit Antrego.",
			highlight_word: "Kontrolle",
			risk_of_error: "Reduziert das Fehlerrisiko.",
			text: "Antrego transformiert Logistikabläufe für Exporteure, Importeure, Spediteure und Hersteller mit End-to-End-Digitallösungen für Bestandsmanagement, Echtzeit-Sendungsverfolgung und automatisierte Dokumentation.",
			time_and_cost_savings: "Spart Zeit und Kosten.",
		},
		$content: {
			$text: {
				0: "Verfolgen Sie alle Ihre Sendungen an einem Ort und kontrollieren Sie Ihre Finanzen mit dynamischen Berichten.",
				1: "Teilen Sie Ihre Echtzeit-Updates mit Ihren Kunden, um Ihre Servicequalität zu verbessern.",
				2: "Sehen und teilen Sie alle Dokumente zu Ihrer Sendung in einem System.",
				3: "Kontrollieren Sie Ihren Prozess einfach, indem Sie von allen Geräten und Standorten auf Antrego zugreifen.",
				4: "Speichern Sie alle Ihre Daten mit SHA-256-Verschlüsselungstechnologie. Seien Sie sicher bezüglich der Sicherheit.",
				5: "Beteiligen Sie sich an der gemeinsamen Verfolgung mit allen Beteiligten im Geschäftsprozess. Verwalten Sie den Prozess effizienter.",
			},
			$title: {
				0: "End-to-End Sendungsmanagement",
				1: "Echtzeit-Kundenkommunikation",
				2: "Zentralisiertes Dokumentenmanagement",
				3: "Cloudbasierter Zugriff überall",
				4: "Sicherheit auf Enterprise-Niveau",
				5: "Zusammenarbeit mit mehreren Parteien",
			},
			content_title: "Alles, was Sie brauchen, in einer Plattform",
		},
		$home: {
			subtitle: "Verwalten Sie Bestände, Sendungen, Dokumente & Tracking in einer leistungsstarken Plattform",
			text: "Sparen Sie 40 % Zeit im Betrieb mit automatisierten Workflows. Schließen Sie sich 500+ Unternehmen an, die ihre Logistikabläufe weltweit optimieren.",
			title: "Komplette Logistikplattform: Von Bestand bis Lieferung",
		},
		$lifecycle: {
			headline: "Prozess",
			info_button: "Informationen erhalten",
			lifecycle_texts: {
				0: "Laden Sie zusätzliche Dateien hoch, um Ihre Proforma-Rechnung zu erstellen, und teilen Sie diese sofort mit Ihrem Kunden.",
				1: "Geben Sie Ihre Versanddetails ein und fügen Sie Dokumente hinzu. Benachrichtigen Sie Ihren Kunden und verwalten Sie alle Versandprozesse gemeinsam über einen einzigen Kanal.",
				2: "Verfolgen Sie Ihre finanzielle Situation im Zusammenhang mit Import und Export in Echtzeit.",
			},
			lifecycle_titles: {
				0: "Anmelden und Proforma-Rechnung erstellen",
				1: "Sendung erstellen",
				2: "Finanzielle Aktivitäten verfolgen",
			},
			productivity_title: "Steigern Sie die Produktivität und reduzieren Sie die Komplexität in 3 Schritten.",
			tracking_guide_title: "Einfache Verfolgungsanleitung",
		},
		$logistics: {
			logistics_title: "Unterstützte Logistikarten",
			solutions_title: "Die richtige Lösung für jede Last",
			text: "Mit Antrego, Ihrem digitalen Partner für alle Arten des Transports, stehen wir Ihnen für all Ihre globalen Bewegungen zur Seite.",
		},
		$pdfEditor: {
			$detailPage: {
				hero_title: "Professionelle PDF-Dokumenterstellung",
				hero_subtitle: "In wenigen Minuten beeindruckende Geschäftsdokumente erstellen",
				hero_description:
					"Der intuitive PDF-Editor von Antrego ermöglicht es Ihnen, professionelle Rechnungen, Proforma-Rechnungen und Geschäftsdokumente einfach zu entwerfen, anzupassen und zu generieren – ganz ohne Designkenntnisse.",
				features_title: "Alles für professionelle Dokumente",
				feature_1_title: "Drag-&-Drop-Editor",
				feature_1_desc:
					"Fügen Sie Texte, Bilder, Logos und Tabellen per Drag & Drop hinzu. Keine technischen Kenntnisse erforderlich.",
				feature_2_title: "Individuelle Vorlagen",
				feature_2_desc:
					"Wählen Sie aus vorgefertigten Vorlagen oder erstellen Sie eigene Layouts im Corporate Design. Speichern Sie Vorlagen für konsistente Markenauftritte.",
				feature_3_title: "Intelligente Formularfelder",
				feature_3_desc:
					"Kundeninformationen, Produktdetails und Preise werden automatisch gefüllt. Direkt mit Ihren Sendungs- und Bestandsdaten verbunden.",
				feature_4_title: "Marken-Anpassung",
				feature_4_desc:
					"Fügen Sie Ihr Logo hinzu, wählen Sie Markenfarben, passen Sie Schriften an und erstellen Sie Dokumente, die Ihre Unternehmensidentität perfekt widerspiegeln.",
				feature_5_title: "Export in mehreren Formaten",
				feature_5_desc:
					"Als PDF herunterladen, direkt drucken oder per E-Mail teilen. Alle Dokumente sind professionell formatiert und druckfertig.",
				feature_6_title: "Versionskontrolle",
				feature_6_desc:
					"Verfolgen Sie Überarbeitungen, erhalten Sie Verlauf und greifen Sie auf frühere Versionen zu. Wichtige Iterationen gehen nie verloren.",
				benefits_title: "Warum den Antrego PDF-Editor?",
				benefit_1: "Erstellen Sie professionelle Dokumente 10× schneller als mit herkömmlichen Methoden",
				benefit_2: "Sorgen Sie für konsistente Markenführung in allen Geschäftsdokumenten",
				benefit_3: "Reduzieren Sie Fehler durch automatische Datenübernahme aus Ihren Sendungen",
				benefit_4: "Sparen Sie Zeit mit wiederverwendbaren Vorlagen und smarten Formularen",
				benefit_5: "Beeindrucken Sie Kunden mit hochwertigen, professionell aussehenden Dokumenten",
				benefit_6: "Greifen Sie von jedem Gerät jederzeit auf Ihre Dokumente zu",
				workflow_title: "So funktioniert die Dokumenterstellung",
				step_1_title: "Vorlage wählen",
				step_1_desc:
					"Wählen Sie aus vorgefertigten Vorlagen oder starten Sie auf leerer Fläche, um Ihr individuelles Layout zu erstellen.",
				step_2_title: "Inhalte anpassen",
				step_2_desc:
					"Elemente per Drag & Drop platzieren, Logo und Branding hinzufügen, Felder automatisch mit Sendungsdaten befüllen.",
				step_3_title: "Vorschau & Bearbeiten",
				step_3_desc:
					"Überprüfen Sie das Dokument in Echtzeit, nehmen Sie Anpassungen vor und stellen Sie Perfektion vor der Generierung sicher.",
				step_4_title: "Generieren & Teilen",
				step_4_desc:
					"Als PDF herunterladen, direkt an Kunden senden oder Sendungen anhängen. Vorlage für die Zukunft speichern.",
				cta_title: "Starten Sie noch heute mit professionellen Dokumenten",
				cta_button: "Kostenlos loslegen",
				cta_subtitle: "Keine Kreditkarte erforderlich • In Minuten einsatzbereit",
			},
			description:
				"Unser PDF-Editor ist ein leistungsstarkes Tool, das das Erstellen und Bearbeiten von Rechnungen praktischer macht. Sparen Sie Zeit und präsentieren Sie Ihren Geschäftspartnern professionell aussehende Dokumente.",
			features: {
				design:
					"Rechnungsdesign: Fügen Sie Ihr Logo hinzu, passen Sie Farben an und individualisieren Sie Ihr Rechnungsformat.",
				edit: "Dokumentbearbeitung: Bearbeiten Sie PDFs schnell, fügen Sie Text hinzu oder entfernen Sie ihn.",
				shareSave:
					"Teilen und Speichern: Laden Sie Ihre erstellten Dokumente herunter, teilen Sie sie oder speichern Sie sie direkt auf der Plattform.",
			},
			longTitle: "Schnelle und personalisierte Rechnungen mit dem PDF-Editor.",
			note: "Dieses Setup ermöglicht es Benutzern, Funktionen visuell zu erkunden und Vorteile schriftlich zu überprüfen.",
			title: "Rechnungen erstellen ist so einfach!",
		},
		$process: {
			comparison_subtitle: "Der Unterschied zwischen traditionellem und digitalem Logistikmanagement",
			digital_future: "Verabschieden Sie sich von traditionellen Methoden und betreten Sie die digitale Zukunft",
			digital_shipping: "Digitale Sendungsverfolgung mit Antrego",
			digital_shipping_texts: {
				0: "Proforma-Rechnungen für eingehende Bestellungen werden einfach über einen einzigen Kanal erstellt und verfolgt.",
				1: "Proforma-Rechnungen werden gesendet, Benachrichtigungen gehen sofort an den Kunden und sie werden über Antrego genehmigt.",
				2: "Dokumentenprozesse werden über Antrego verwaltet. Sie gehen nicht verloren, es treten keine Verzögerungen auf und das Fehlerrisiko wird minimiert.",
				3: "Lieferanten, Kunden und Zollmakler können die Versanddetails sofort sehen und gemeinsam verfolgen.",
				4: "Finanzberichte werden automatisch monatlich und jährlich erstellt.",
			},
			question_title: "Wie Antrego Ihnen 10+ Stunden pro Woche spart",
			tracking_method: "Digitalisieren Sie Ihre Verfolgungsmethoden und beschleunigen Sie Ihre Prozesse.",
			traditional_shipping: "Traditionelle Sendungsverfolgung",
			traditional_shipping_texts: {
				0: "Bestellungen werden über E-Mail, Nachrichten oder Telefon über verschiedene Kanäle gesammelt, was interne Verfolgungsprobleme verursacht.",
				1: "Die Proforma-Rechnung wird mit Tools wie Excel erstellt und der Genehmigungsprozess wird manuell über E-Mail, WhatsApp oder Telefon abgewickelt.",
				2: "Manuelle Dokumentenprozesse führen zu Fehlern und Verzögerungen, was Zeit- und finanzielle Verluste verursacht.",
				3: "Es gibt keine gemeinsame Plattform für Lieferanten, Kunden und Zollmakler, um Versanddetails zu verfolgen.",
				4: "Finanzielle Daten werden nach jeder Sendung einzeln überprüft, was die Berichterstellung erschwert.",
			},
		},
		$question: {
			$text: {
				0: "<p>Antrego ist eine umfassende Logistikmanagement-Plattform, mit der Unternehmen Sendungen verfolgen, Bestände verwalten und in Echtzeit mit Kunden zusammenarbeiten. Sie digitalisiert Ihren gesamten Supply-Chain-Prozess von Bestand bis Lieferung.</p>",
				1: "<p>Antrego vereinfacht die Logistik mit Einfachem Zugriff von jedem Gerät, Datensicherheit auf Enterprise-Niveau mit SHA-256-Verschlüsselung und Gemeinsamer Verfolgung, die alle Beteiligten während des gesamten Sendungsprozesses informiert hält.</p>",
				2: "<p>Antrego unterstützt alle wichtigen Transportarten, darunter Seefracht, Luftfracht, Landtransport und Schienenlogistik. Wir arbeiten mit allen großen Carriern und Reedereien weltweit zusammen.</p>",
				3: "<p>Antrego bietet einen kostenlosen Plan für bis zu 10 Sendungen pro Monat – keine Kreditkarte erforderlich. Premium-Pläne beginnen bei 99 $/Monat für unbegrenzte Sendungen; bei jährlicher Zahlung sparen Sie 16 %. Details siehe unsere Preisseite.</p>",
				4: "<p>Wir entwickeln derzeit API-Zugriff und Integrationen mit gängigen Logistik- und ERP-Systemen. Integrationsfunktionen sind für zukünftige Releases geplant. Kontaktieren Sie uns, um mehr über unsere Roadmap zu erfahren.</p>",
				5: "<p>Die meisten Unternehmen sind innerhalb von 24 Stunden startklar. Die Grundeinrichtung dauert nur 5–10 Minuten, um Ihr Konto anzulegen und Firmendaten hinzuzufügen. Unser Onboarding-Team hilft beim Datenimport und bei der Workflow-Anpassung.</p>",
			},
			$title: {
				0: "Was ist Antrego?",
				1: "Warum sollte ich Antrego nutzen?",
				2: "Welche Logistikarten unterstützt Antrego?",
				3: "Was kostet Antrego?",
				4: "Kann ich Antrego in bestehende Systeme integrieren?",
				5: "Wie lange dauert die Einrichtung von Antrego?",
			},
			save_percentage: "Sparen Sie 16% pro Monat",
			text: "Zugreifen Sie mühelos auf alle Informationen mit Antrego und kontaktieren Sie uns für weitere Fragen.",
			title: "Erfahren Sie schnell, was Sie interessiert",
		},
		$stockFeature: {
			$detailPage: {
				hero_title: "Ihr Bestandsmanagement transformieren",
				hero_subtitle: "Vom Bestand bis zum Verkauf – den gesamten Produktlebenszyklus digital verwalten",
				hero_description:
					"Die Bestandsverwaltung von Antrego ermöglicht Exporteuren und Herstellern, Bestände effizient zu managen, Produktkataloge mit Kunden zu teilen und den Verkaufsprozess in einer integrierten Plattform zu beschleunigen.",
				features_title: "Leistungsstarke Funktionen für das Bestandsmanagement",
				feature_1_title: "Zentralisierte Bestandsverwaltung",
				feature_1_desc:
					"Verwalten Sie alle Artikel in einem Dashboard. Verfolgen Sie Mengen, Losnummern, Lager und Produktdetails mühelos.",
				feature_2_title: "Öffentlicher Warenkatalog",
				feature_2_desc:
					"Erstellen Sie eine öffentliche Katalogseite, um Ihre verfügbaren Produkte weltweit zu präsentieren. Teilen Sie Ihren Bestand über einen einfachen Link.",
				feature_3_title: "Chargenverfolgung",
				feature_3_desc:
					"Verfolgen Sie einzelne Chargen mit detaillierten Informationen, einschließlich Mengen, Abmessungen und benutzerdefinierten Attributen – für präzises Bestandsmanagement.",
				feature_4_title: "Unterstützung mehrerer Lager",
				feature_4_desc:
					"Organisieren Sie Ihre Bestände über mehrere Lager und Standorte. Behalten Sie stets den Überblick, wo welche Produkte liegen.",
				feature_5_title: "Produkt-Bildergalerie",
				feature_5_desc:
					"Laden Sie mehrere Bilder pro Artikel hoch, um Kunden und Teammitgliedern visuelle Klarheit zu bieten.",
				feature_6_title: "Direkt zur Sendung",
				feature_6_desc:
					"Wandeln Sie Bestandsartikel nahtlos in Sendungen um. Erstellen Sie Proforma-Rechnungen und Versanddokumente direkt aus dem Bestand.",
				benefits_title: "Warum Antrego für das Bestandsmanagement?",
				benefit_1: "Steigern Sie die Sichtbarkeit Ihrer Produkte bei Käufern weltweit",
				benefit_2: "Reduzieren Sie den Zeitaufwand für manuelle Bestandsverfolgung",
				benefit_3: "Verschlanken Sie den Übergang vom Bestand zum Verkauf",
				benefit_4: "Stellen Sie Kunden Echtzeit-Bestandsinformationen bereit",
				benefit_5: "Unterstützung für 15+ Sprachen zur Erschließung internationaler Märkte",
				benefit_6: "Integriert mit Versand- und Abrechnungssystemen",
				workflow_title: "So funktioniert’s",
				step_1_title: "Produkte hinzufügen",
				step_1_desc: "Erstellen Sie Artikel mit Details wie Produktinformationen, Mengen, Lagern und Bildern.",
				step_2_title: "Katalog teilen",
				step_2_desc:
					"Generieren Sie einen öffentlichen Link zu Ihrem Warenkatalog, den potenzielle Kunden jederzeit ansehen können.",
				step_3_title: "Anfragen erhalten",
				step_3_desc:
					"Kunden können Ihre verfügbaren Produkte einsehen und Sie direkt für Bestellungen und Angebote kontaktieren.",
				step_4_title: "In Verkäufe umwandeln",
				step_4_desc:
					"Erstellen Sie einfach Proforma-Rechnungen und Sendungen aus Ihren Artikeln, um Kundenaufträge zu erfüllen.",
				cta_title: "Bereit, Ihr Bestandsmanagement zu modernisieren?",
				cta_button: "Kostenlos loslegen",
				cta_subtitle: "Keine Kreditkarte erforderlich • In Minuten eingerichtet",
			},
			access_potential_customers: "Erreichen Sie potenzielle Kunden schnell",
			desc: "Antrego wurde speziell für Exporteure und Hersteller entwickelt und beschleunigt Ihre Verkaufs- und Marketingprozesse. Wachsen Sie mit Bestandsmanagement, Kundenbestandsfreigabe und Sendungsverfolgung!",
			global_market: "Erreichen Sie den globalen Markt mit Unterstützung in 15 verschiedenen Sprachen",
			main_title: "Die nächste Generation Lösung für Vertrieb und Marketing",
			manage_stocks: "Verwalten und teilen Sie Ihre Bestände sofort",
			speed_up_sales: "Beschleunigen Sie Verkaufsprozesse",
			title: "Von Lager zu Verkauf",
		},
		$tracking: {
			$detailPage: {
				hero_title: "Echtzeit-Sendungsverfolgung",
				hero_subtitle: "Jeden Container, jeden Schritt im Blick",
				hero_description:
					"Das fortschrittliche Tracking von Antrego bietet vollständige Transparenz über Ihre Sendungen mit Echtzeit-Updates, automatischen Benachrichtigungen und umfassenden Statusberichten. Verlieren Sie nie wieder einen Container aus den Augen.",
				features_title: "Komplette Tracking-Lösung",
				feature_1_title: "Live-Container-Tracking",
				feature_1_desc:
					"Verfolgen Sie Ihre Container in Echtzeit mit präzisen Standort-Updates und ETA für jede Sendung.",
				feature_2_title: "Automatische Benachrichtigungen",
				feature_2_desc:
					"Erhalten Sie sofortige Alerts zu wichtigen Meilensteinen: Verladung, Abfahrt, Ankunft, Zollfreigabe und Lieferstatus.",
				feature_3_title: "Statusverlauf",
				feature_3_desc:
					"Greifen Sie auf die komplette Sendungshistorie mit detaillierten Protokollen aller Bewegungen, Statusänderungen und Schlüsselereignisse zu.",
				feature_4_title: "Sichtbarkeit für alle Beteiligten",
				feature_4_desc:
					"Teilen Sie Tracking-Informationen mit Kunden, Lieferanten und Zollagenten. Alle bleiben automatisch informiert.",
				feature_5_title: "Dokumentenmanagement",
				feature_5_desc:
					"Hängen Sie alle Versanddokumente an und greifen Sie darauf zu – einschließlich Konnossemente, Zolldokumente und Zertifikate – an einem Ort.",
				feature_6_title: "Verspätungswarnungen",
				feature_6_desc:
					"Erhalten Sie proaktive Hinweise auf mögliche Verzögerungen oder Probleme, damit Sie frühzeitig gegensteuern können.",
				benefits_title: "Warum Antrego Tracking?",
				benefit_1: "Weniger Kundenanfragen durch Self-Service-Tracking",
				benefit_2: "Teure Verzögerungen durch proaktives Monitoring vermeiden",
				benefit_3: "Kundenzufriedenheit durch transparente Kommunikation steigern",
				benefit_4: "Zeitersparnis durch automatische Status-Updates an alle Beteiligten",
				benefit_5: "Risiken minimieren dank Echtzeit-Transparenz zum Sendungsstatus",
				benefit_6: "Professionelle Tracking-Seiten stärken Ihr Markenimage",
				workflow_title: "So funktioniert das Tracking",
				step_1_title: "Sendung anlegen",
				step_1_desc: "Tragen Sie Details wie Container-Nummern, Routen und erwartete Termine in das System ein.",
				step_2_title: "Automatische Updates",
				step_2_desc: "Das System verfolgt Container automatisch und aktualisiert den Status bei jedem Checkpoint.",
				step_3_title: "Benachrichtigungen für Beteiligte",
				step_3_desc: "Alle Parteien erhalten sofortige Informationen zu wichtigen Meilensteinen und Statusänderungen.",
				step_4_title: "Lieferbestätigung",
				step_4_desc: "Erhalten Sie die finale Lieferbestätigung mit vollständiger Dokumentation und Sendungshistorie.",
				cta_title: "Starten Sie mit sicherem Tracking Ihrer Sendungen",
				cta_button: "Kostenlos loslegen",
				cta_subtitle: "Keine Kreditkarte erforderlich • Heute mit dem Tracking starten",
			},
			control_title: "Übernehmen Sie die Kontrolle über Ihre Sendungen mit Antrego.",
			real_time_alerts:
				"Echtzeitwarnungen: Erhalten Sie sofortige Benachrichtigungen und umfassende Statusupdates für jeden Container.",
			secure_data_handling:
				"Sichere Datenverarbeitung: Laden Sie Ihre Sendungsdaten direkt auf der Plattform einfach herunter, teilen oder speichern Sie sie.",
			tracking_description:
				"Antregos Container-Tracking-Lösung bietet eine schnelle und effiziente Möglichkeit, Ihre Sendungen in Echtzeit zu überwachen. Behalten Sie die Kontrolle und beeindrucken Sie Ihre Partner mit detaillierten, professionellen Updates.",
			tracking_title: "Verfolgen Sie Ihre Sendungen mühelos!",
		},
		cancel_anytime: "Jederzeit kündigen",
		customize_package:
			"Sie können zusätzlichen Speicherplatz und Benutzer erwerben und Ihr Paket nach Ihren Bedürfnissen anpassen",
		free_features_1: "10 Sendungen",
		free_features_2: "100 MB Speicherplatz",
		free_features_3: "Unbegrenzte Geschäftspartner",
		free_features_4: "1 Benutzer",
		free_plan: "Kostenlos",
		free_price: "0€",
		free_regeneration: "",
		free_title: "Monatlich",
		premium_annual_features_1: "20 Benutzer",
		premium_annual_features_2: "100 Partner",
		premium_annual_features_3: "1000 Sendungen",
		premium_annual_features_4: "1000 Rechnungen",
		premium_annual_price: "83,25€",
		premium_annual_regeneration: "Wird jährlich für 999€ erneuert",
		premium_annual_title: "Jährlich",
		premium_monthly_features_1: "Unbegrenzte Sendungen",
		premium_monthly_features_2: "Unbegrenzte Geschäftspartner",
		premium_monthly_features_3: "2 GB Speicherplatz",
		premium_monthly_features_4: "3 Benutzer",
		premium_monthly_price: "99€",
		premium_monthly_regeneration: "Wird monatlich für 99€ erneuert",
		premium_monthly_title: "Monatlich",
		premium_plan: "Premium-Plan",
		premium_plus_annual_features_1: "Unbegrenzte Sendungen",
		premium_plus_annual_features_2: "Unbegrenzte Geschäftspartner",
		premium_plus_annual_features_3: "5 GB Speicherplatz",
		premium_plus_annual_features_4: "5 Benutzer",
		premium_plus_annual_price: "83,25€",
		premium_plus_annual_regeneration: "Wird jährlich für 999€ erneuert",
		premium_plus_annual_title: "Jährlich",
		premium_plus_monthly_features_1: "Unbegrenzte Sendungen",
		premium_plus_monthly_features_2: "Unbegrenzte Geschäftspartner",
		premium_plus_monthly_features_3: "5 GB Speicherplatz",
		premium_plus_monthly_features_4: "5 Benutzer",
		premium_plus_monthly_price: "249€",
		premium_plus_monthly_regeneration: "Wird monatlich für 249€ erneuert",
		premium_plus_monthly_title: "Monatlich",
		premium_plus_plan: "Premium Plus",
		pricing_text: "Wir können Ihre Bedürfnisse bestmöglich erfüllen, ohne Ihr Budget zu sprengen.",
		pricing_title: "Antrego garantiert, das beste Paket und den besten Preis für Sie anzubieten.",
		save_percentage: "Sparen Sie 16% monatlich",
	},
	$language: {
		ar: "العربية",
		de: "Deutsch",
		en: "English",
		es: "Español",
		fr: "Français",
		hi: "हिन्दी",
		ind: "Bahasa Indonesia",
		it: "Italiano",
		ja: "日本語",
		ko: "한국어",
		pt: "Português",
		ru: "Русский",
		tr: "Türkçe",
		vi: "Tiếng Việt",
		zh: "中文",
	},
	$languageLocal: {
		ar: "Arabisch",
		de: "Deutsch",
		en: "Englisch",
		es: "Spanisch",
		fr: "Französisch",
		hi: "Hindi",
		ind: "Indonesisch",
		it: "Italienisch",
		ja: "Japanisch",
		ko: "Koreanisch",
		pt: "Portugiesisch",
		ru: "Russisch",
		tr: "Türkisch",
		vi: "Vietnamesisch",
		zh: "Chinesisch",
	},
	$message: {
		cannot_delete_verified_partner: "Sie können einen verifizierten Partner nicht löschen.",
		confirm: "Sind Sie sicher, dass Sie {function} möchten?",
		created: "{item} erstellt.",
		deleted: "{item} gelöscht.",
		edited: "{item} wurde bearbeitet.",
		error_on_view_file: "Beim Anzeigen der Datei ist ein Fehler aufgetreten.",
		file_oversize: "Die Dateigröße darf maximal {size} betragen.",
		invalid: "Ungültiges {item}",
		migrated: "{item} migriert. ({value})",
		process_has_been_started: "Ihr {item} wurde gestartet.",
		saved: "{item} wurde gespeichert.",
		sent: "{item} gesendet.",
		sent_email: "E-Mail gesendet. ({value})",
		sign_in_failed: "E-Mail oder Passwort ist falsch",
		unsupported_file_type: "Nicht unterstützter Dateityp",
		updated: "{item} aktualisiert.",
	},
	$pageDescriptions: {
		landing_page:
			"Antrego – Komplette Logistikplattform für Exporteure, Importeure & Spediteure. Sendungen in Echtzeit verfolgen, Bestände verwalten, Rechnungen erstellen & Dokumentation automatisieren. Sparen Sie 40 % Zeit mit digitalen Logistiklösungen. Jetzt testen!",
		stock_feature:
			"Transformieren Sie Ihr Bestandsmanagement mit Antrego. Bestände verwalten, öffentliche Kataloge erstellen, Chargen über mehrere Lager verfolgen und Bestände sofort in Sendungen umwandeln. Ideal für Exporteure und Hersteller.",
		tracking_feature:
			"Echtzeit-Container- und Sendungsverfolgung mit Antrego. Jeden Container mit Live-Updates, automatischen Benachrichtigungen, vollständigem Statusverlauf und Sichtbarkeit für alle Beteiligten überwachen. Verlieren Sie nie wieder den Überblick.",
		pdf_feature:
			"Professioneller PDF-Dokument-Editor für die Logistik. Individuelle (Proforma-)Rechnungen mit Drag-&-Drop-Editor, Vorlagen und automatischer Datenübernahme erstellen. In Minuten beeindruckende Dokumente erzeugen.",
		benefits_feature:
			"Entdecken Sie die Vorteile der Antrego-Plattform. Zentrales Dashboard, höhere Genauigkeit, Zeitersparnis, Team-Zusammenarbeit, Kostensenkung und Skalierbarkeit. Transformieren Sie noch heute Ihre Logistikabläufe.",
		contact:
			"Kontaktieren Sie Antrego – Für Fragen, Demos oder Support. Wir helfen Ihnen gerne, Ihre Logistikprozesse zu transformieren.",
		sign_in:
			"Bei Antrego anmelden – Greifen Sie auf Ihr Logistik-Dashboard zu, um Sendungen zu verwalten, Container zu verfolgen, Rechnungen zu erstellen und im Team zusammenzuarbeiten. Sicheres Login-Portal.",
		sign_up:
			"Bei Antrego registrieren – Erstellen Sie Ihr kostenloses Konto und starten Sie mit der Verwaltung Ihrer Logistikabläufe. 10 kostenlose Sendungen pro Monat. Keine Kreditkarte erforderlich.",
	},
	$pageTitles: {
		accept_invitation: "Einladung annehmen",
		benefits_feature: "Plattformvorteile – Komplette Logistiklösung",
		company_profile: "Firmenprofil",
		contact: "Kontakt – Nehmen Sie Kontakt mit Antrego auf",
		home: "Startseite",
		landing_page: "Verwalten Sie alle Ihre Versandprozesse digital",
		partners: "Partner",
		pdf_editor: "PDF-Editor",
		pdf_feature: "PDF-Dokument-Editor – Professionelle Rechnungen",
		product_details: "Produktdetails",
		product_groups: "Produktgruppen",
		products: "Produkte",
		proforma_invoices: "Proforma-Rechnungen",
		shipment_details: "Sendungsdetails",
		shipments: "Sendungen",
		sign_in: "Anmelden",
		sign_up: "Registrieren",
		stock_details: "Bestandsdetails",
		stock_feature: "Bestandsmanagement – Ihren Bestand transformieren",
		stocks: "Bestände",
		subscription: "Abonnement",
		tracking_feature: "Sendungsverfolgung – Container in Echtzeit überwachen",
		user_profile: "Benutzerprofil",
	},
	$partnershipStatusTooltip: {
		createdHereDescription:
			"Nicht registrierte Partner, Sie haben ihr Profil auf unserer Plattform erstellt, sodass Sie ihre Informationen anzeigen und bearbeiten können.",
		createdHereTitle: "Hier erstellt:",
		description: "Sie können den Status Ihrer Beziehung zu Ihren Partnern verfolgen. Hier sind die Unterschiede:",
		verifiedPartnersDescription:
			"Diese Partner haben Ihre Einladung angenommen und sich auf der Plattform registriert. Ihre Informationen sind nur zur Ansicht und können nicht bearbeitet werden.",
		verifiedPartnersTitle: "Verifizierte Partner:",
	},
	$productGroup: {
		add_child: "Kind hinzufügen",
		add_new_product_group: "Neue Produktgruppe hinzufügen",
		add_to_root: "Zur Wurzel hinzufügen",
		has_children_fail_message: "Eine Produktgruppe mit Kind kann nicht gelöscht werden",
		initial_message: "Verwenden Sie diese {0}-Schaltfläche, um Ihre erste Produktgruppe zu erstellen.",
		name: "Produktgruppenname",
		number_of_product: "Anzahl der Produkte",
	},
	$proformaInvoice: {
		$actionDescription: {
			approve: "{name} genehmigt.",
			create: "Erstellt von {name}.",
			create_attachment: "{name} hat einen Anhang erstellt.",
			delete_attachment: "{name} hat einen Anhang gelöscht.",
			demand_revise: "{name} forderte eine Überarbeitung.",
			mark_as_processed: "{name} als bearbeitet markiert.",
			reject: "{name} abgelehnt.",
			revoke: "{name} widerrufen.",
			send: "{name} an den Empfänger zur Bewertung gesendet.",
			update: "Aktualisiert von {name}.",
			update_attachment: "{name} hat einen Anhang aktualisiert.",
		},
		$actions: {
			approve: "Genehmigen",
			demand_revise: "Überarbeitung fordern",
			mark_as_approved: "Genehmigt",
			mark_as_processed: "Bearbeitet",
			mark_as_rejected: "Abgelehnt",
			mark_as_revise_demanded: "Überarbeitung gefordert",
			mark_as_revoked: "Widerrufen",
			mark_as_sent: "Gesendet",
			reject: "Ablehnen",
			revoke: "Widerrufen",
			send: "Senden",
		},
		$status: {
			approved: "Genehmigt",
			pending_approval: "Genehmigung ausstehend",
			pending_revise: "Überarbeitung ausstehend",
			processed: "Bearbeitet",
			rejected: "Abgelehnt",
			revoked: "Widerrufen",
			template: "Vorlage",
		},
		approve_confirm_message: "Sind Sie sicher, dass Sie die Proforma-Rechnung genehmigen möchten?",
		approve_success_message: "Die Proforma-Rechnung wurde genehmigt.",
		demand_revise_description_message: "Bitte geben Sie einige Details zu Ihrer Überarbeitungserwartung an:",
		demand_revise_success_message: "Die Proforma-Rechnung wurde zur Überarbeitung an den Absender zurückgesendet.",
		mark_as_processed_confirm_message: "Bestätigen Sie, dass die Proforma-Rechnung als bearbeitet markiert wird?",
		mark_as_processed_success_message: "Die Proforma-Rechnung wurde als bearbeitet markiert.",
		no_attachment_text: "Es wurde noch kein Anhang hinzugefügt.",
		reject_confirm_message: "Sind Sie sicher, dass Sie die Proforma-Rechnung ablehnen möchten?",
		reject_success_message: "Die Proforma-Rechnung wurde abgelehnt.",
		revoke_confirm_message: "Sind Sie sicher, dass Sie die Proforma-Rechnung widerrufen möchten?",
		revoke_success_message: "Die Proforma-Rechnung wurde widerrufen.",
		send_confirm_message: "Bestätigen Sie das Senden der Proforma-Rechnung an den Empfänger?",
		send_success_message: "Die Proforma-Rechnung wurde gesendet.",
	},
	$seoTitles: {
		landing_page: "Antrego | Logistik-Management-Software - Verfolgen, Verwalten, Automatisieren",
		stock_feature: "Inventarverwaltungssoftware | Bestandsverfolgungssystem | Antrego",
		tracking_feature: "Echtzeit-Sendungsverfolgungssoftware | Container-Tracking | Antrego",
		pdf_feature: "Proforma-Rechnungsgenerator | PDF-Editor für die Logistik | Antrego",
		benefits_feature: "Vorteile einer kompletten Logistikplattform | All-in-One-Lösung | Antrego",
	},
	$serviceMessage: {
		already_subs_module: "Es gibt bereits ein Abonnement für dieses Modul.",
		bad_request: "Fehlerhafte Anfrage",
		code_already_used: "Der Code wurde bereits verwendet.",
		container_status_not_available: "Containerstatus ist nicht verfügbar.",
		existing_email_warning: "E-Mail existiert bereits.",
		existing_employee_error: "Dieser Benutzer wurde bereits zu Ihrem Unternehmen hinzugefügt.",
		existing_employee_for_email_warning: "Einladungscode wurde bereits an diese E-Mail gesendet",
		existing_invitation_warning: "Einladungscode wurde bereits an diese E-Mail gesendet.",
		existing_token_already_have_time: "Der bestehende Token hat bereits genügend Zeit zur Verwendung.",
		existing_user: "Benutzer existiert bereits.",
		five_min_reset_password_mail:
			"Sie müssen mindestens 5 Minuten warten, nachdem Sie einmal eine E-Mail zur Passwortzurücksetzung angefordert haben.",
		forbidden: "Verboten",
		have_no_corporation: "Sie haben keine Firma",
		have_no_custom_agency: "Sie haben keine Zollbehörde",
		have_no_employee: "Sie haben keinen Mitarbeiter",
		instance_can_no_delete_existing_booking_code:
			"Die Instanz kann aufgrund eines vorhandenen Buchungscodes nicht gelöscht werden.",
		instance_cannot_delete: "Die Instanz kann nicht mehr gelöscht werden.",
		instance_not_found: "Instanz nicht gefunden.",
		internal_server_error: "Interner Serverfehler",
		invalid_current_password: "Ungültiges aktuelles Passwort.",
		invalid_identifier_or_password: "Ungültiger Bezeichner oder Passwort",
		invalid_invitation_code: "Der Einladungscode ist falsch.",
		invalid_moving_request: "Ungültige Umzugsanfrage",
		invalid_operation: "Ungültiger Vorgang",
		invalid_refresh_token: "Ungültiger Aktualisierungs-Token.",
		invalid_unit: "Ungültige Einheit",
		invitation_accepting_is_due_to_the_admin: "Die Annahme der Einladung erfolgt durch den Administrator.",
		invitation_already_discarded: "Die Einladung wurde bereits verworfen.",
		invitation_already_used: "Die Einladung wurde bereits verwendet.",
		invitation_has_been_used: "Die Einladung wurde verwendet.",
		invitation_not_exist_email: "Die Einladung existiert nicht an der E-Mail-Adresse.",
		invitation_not_for_company: "Diese Einladung ist nicht für ein Unternehmen.",
		invitation_not_for_custom_agency: "Diese Einladung ist nicht für eine Zollbehörde.",
		invitation_not_found: "Die Einladung wurde nicht gefunden.",
		invitation_not_valid: "Die Einladung ist nicht mehr gültig.",
		link_has_been_expired: "Link ist abgelaufen.",
		link_not_be_used_anymore: "Dieser Link darf nicht mehr verwendet werden",
		missing_required_fields: "Erforderliche Felder fehlen.",
		no_employee_found: "Kein Mitarbeiter gefunden",
		no_proper_partner_found: "Kein geeigneter Partner gefunden.",
		not_acceptable: "Nicht akzeptabel",
		not_allowed_action: "Sie sind für diese Aktion nicht berechtigt.",
		not_allowed_use_api: "Sie sind nicht berechtigt, diese API zu verwenden.",
		not_found: "Nicht gefunden",
		not_have_purchase_subscription:
			"Ihr Abonnement hat das maximale Limit für Definitionen erreicht. Um weitere hinzuzufügen, erwägen Sie bitte, Ihr Abonnement zu aktualisieren.",
		not_permitted_use_api: "Sie dürfen diese API nicht verwenden.",
		own_invitation_cannot_accept: "Sie können Ihre eigene Einladung nicht annehmen.",
		parent_group_not_found: "Übergeordnete Gruppe nicht gefunden",
		partnerId_required: "Partner-ID erforderlich.",
		partnership_already_exists: "Die Partnerschaft wurde bereits hinzugefügt.",
		password_cant_involve_space_char: "Das Passwort darf keine Leerzeichen enthalten.",
		password_min_chars_least: "Das Passwort muss mindestens 6 Zeichen lang sein.",
		payment_required: "Bitte abonnieren Sie für diesen Prozess.",
		paytr_integration_error:
			"Es gab ein Problem mit der Zahlungsinfrastruktur. Es wird so schnell wie möglich behoben.",
		ports_are_required: "Häfen sind erforderlich.",
		product_group_tree_not_found: "Produktgruppenbaum nicht gefunden",
		proforma_invoice_action_not_available: "Der Status der Proforma-Rechnung ist für diese Aktion nicht verfügbar.",
		proforma_invoice_template_update: "Proforma-Rechnung muss Vorlage sein, um aktualisiert zu werden.",
		shipment_email_not_exist: "Bitte geben Sie eine gültige E-Mail ein.",
		shipment_method_is_required: "Versandmethode erforderlich.",
		shipping_term_is_required: "Versandbedingungen erforderlich.",
		someone_else_uses_this_email: "Jemand anderes verwendet diese E-Mail-Adresse.",
		someone_else_uses_this_username: "Jemand anderes verwendet diesen Benutzernamen.",
		something_went_wrong: "Etwas ist schiefgelaufen",
		type_can_be_abstract_company: '"type"-Eigenschaft kann nur "abstract_company" sein',
		unauthorized: "Nicht autorisiert",
		undefined_result: "Unbestimmtes Ergebnis",
		unexpected_error_occurred: "Ein unerwarteter Fehler ist aufgetreten",
		unit_already_added: "Einheit wurde bereits hinzugefügt.",
		user_already_employee: "Der Benutzer ist bereits Mitarbeiter.",
		user_already_exists: "Der Benutzer existiert bereits in einem Unternehmen.",
		user_does_not_exist: "Benutzer existiert nicht.",
		user_not_found: "Benutzer nicht gefunden.",
		username_min_chars_error: '"Benutzername" muss mindestens 6 Zeichen lang sein.',
	},
	$shipment: {
		$actionDescription: {
			$land: {
				create_container: "{name} hat ein Fahrzeug hinzugefügt.",
				delete_container: "{name} hat ein Fahrzeug gelöscht.",
				update_container: "{name} hat ein Fahrzeug aktualisiert.",
			},
			create: "Erstellt von {name}.",
			create_attachment: "{name} hat einen Anhang hinzugefügt.",
			create_container: "{name} hat einen Container hinzugefügt.",
			delete_attachment: "{name} hat einen Anhang gelöscht.",
			delete_container: "{name} hat einen Container gelöscht.",
			update: "Aktualisiert von {name}.",
			update_attachment: "{name} hat einen Anhang aktualisiert.",
			update_container: "{name} hat einen Container aktualisiert.",
		},
		$containerStatus: {
			arrived: "Angekommen",
			off_load: "Entladen",
			on_load: "Geladen",
			on_way: "Unterwegs",
			reserved: "Reserviert",
		},
		$method: {
			aerial: "Luft",
			land: "Land",
			railway: "Eisenbahn",
			sea: "See",
		},
		$vehicle: {
			license_number: "Kennzeichen",
		},
		archiving_success_message: "Die Sendung wurde archiviert.",
		leave_message: "Hinterlassen Sie Ihre Nachricht oder Ihren Kommentar",
		no_booking_info:
			"Es wurden noch keine Buchungsinformationen festgelegt. Verwenden Sie die {0}-Schaltfläche, um hinzuzufügen.",
		no_transportation_info:
			"Es wurden noch keine Detailinformationen festgelegt. Verwenden Sie die {0}-Schaltfläche, um festzulegen.",
		un_archiving_success_message: "Die Sendung wurde wiederhergestellt.",
	},
	$shortening: {
		number: "Nr.",
	},
	$socialMedia: {
		facebook: "Facebook",
		instagram: "Instagram",
		linked_in: "LinkedIn",
		twitter: "Twitter",
	},
	$subscription: {
		$message: {
			check_your_payment_method:
				"Ihr Abonnement konnte nicht erneuert werden. Bitte überprüfen Sie Ihre Zahlungsmethode.",
			fail: "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut. Wenn das Problem weiterhin besteht, melden Sie es bitte per E-Mail an info@antrego.net.",
			ok: "Der Kaufprozess wurde eingeleitet. Das Ergebnis des Prozesses wird Ihnen per E-Mail mitgeteilt. Ihr Abonnement wird gestartet, sobald die Zahlung erfolgreich abgeschlossen ist.",
			payment_process_is_ongoing:
				"Ihr Zahlungsvorgang läuft. Das Ergebnis des Prozesses wird Ihnen per E-Mail mitgeteilt. Ihr Abonnement wird gestartet, sobald die Zahlung erfolgreich abgeschlossen ist.",
			success: "Ihr Abonnement wurde erfolgreich erstellt. Sie können Antrego jetzt problemlos nutzen.",
			try_to_get_paid_again: "Ihr Abonnement ist abgelaufen. Klicken Sie hier, um zu erneuern.",
			unsubscribed: "Abgemeldet",
			you_dont_have_any_subscription:
				"Sie haben kein Abonnement. Bitte wählen Sie ein Paket auf der Abonnementseite und beginnen Sie, es problemlos zu nutzen.",
			you_dont_have_any_subscription_text:
				"Wählen Sie das beste Mitgliedschaftsprogramm für sich aus und nutzen Sie alle Möglichkeiten.",
			you_dont_have_any_subscription_title: "Mehr machen mit unseren Plänen",
		},
	},
	$unit: {
		acres: "Acres",
		boxes: "Kisten",
		centimeter: "Zentimeter",
		cubic_meter: "Kubikmeter",
		dozen: "Dutzend",
		feet: "Fuß",
		fluid_ounces: "Flüssigunzen",
		gallons: "Gallonen",
		gram: "Gramm",
		hectare: "Hektar",
		inches: "Zoll",
		kilogram: "Kilogramm",
		kilometer: "Kilometer",
		liter: "Liter",
		meter: "Meter",
		miles: "Meilen",
		milligram: "Milligramm",
		milliliter: "Milliliter",
		millimeter: "Millimeter",
		ounces: "Unzen",
		pallets: "Paletten",
		pieces: "Stücke",
		pounds: "Pfund",
		quarts: "Quarts",
		square_feet: "Quadratfuß",
		square_inches: "Quadratzoll",
		square_kilometer: "Quadratkilometer",
		square_meter: "Quadratmeter",
		square_miles: "Quadratmeilen",
		square_yards: "Quadratyards",
		ton: "Tonnen",
		yards: "Yards",
	},
	$validation: {
		email: "Bitte geben Sie eine gültige E-Mail ein",
		invalid: "Ungültiges {item}",
		max_length: "{item} muss weniger als {length} Zeichen lang sein",
		min_length: "{item} muss mehr als {length} Zeichen lang sein",
		must_length: "{item} muss {length} Zeichen lang sein",
		only_number: "{item} sollte eine Zahl sein",
		password_repeat_warning: "Passwortwiederholung stimmt nicht mit dem neuen Passwort überein.",
		required: "{item} ist erforderlich",
		required_for_default_language: "{item} ist für die Standardsprache des Unternehmens erforderlich.",
		you_must_approve_distance_sales_agreement: "Sie müssen dem Fernabsatzvertrag zustimmen.",
	},
	about: "Über uns",
	accept_invitation: "Einladung annehmen",
	accept_invitation_success_message: "Sie haben die Einladung erfolgreich genutzt.",
	accessibility: "Barrierefreiheit",
	actions: "Aktionen",
	active: "Aktiv",
	activities: "Aktivitäten",
	add: "Hinzufügen",
	add_attribute: "Attribut Hinzufügen",
	add_from_stock: "Aus Bestand hinzufügen",
	add_images: "Bild hinzufügen",
	add_item: "{item} hinzufügen",
	add_manually: "Hier erstellen",
	add_new_employee: "Neuen Mitarbeiter hinzufügen",
	add_new_packaging: "Neue Verpackung hinzufügen",
	add_new_product: "Neues Produkt hinzufügen",
	add_new_stock: "Neuen Bestand hinzufügen",
	add_new_warehouse: "Neues Lager hinzufügen",
	add_stock_batch: "Bestandspartie hinzufügen",
	add_template: "Vorlage hinzufügen",
	add_variant: "Variante Hinzufügen",
	address: "Adresse",
	again: "Wieder",
	alert: "Warnung",
	already_have_employee_message: "Sie sind bereits Mitarbeiter eines Unternehmens.",
	amount: "Betrag",
	approve: "Genehmigen",
	archive: "Archiv",
	attachment: "Anhang",
	attachments: "Anhänge",
	attribute: "Attribut",
	attributes: "Attribute",
	auto_attached_pdf: "Automatisch angehängtes PDF",
	auto_detect: "Automatische Erkennung",
	available: "Verfügbar",
	bank: "Bank",
	basket: "Warenkorb",
	basket_empty: "Ihr Warenkorb ist leer",
	batch: "Charge",
	batch_no: "Chargennummer",
	batches: "Bestandspartien",
	benefits: "Vorteile",
	billed_to: "Rechnung an",
	booking: "Buchung",
	booking_code: "Buchungscode",
	booking_details: "Buchungsdetails",
	boolean: "Boolesch",
	business_partner: "Geschäftspartner",
	business_partners: "Geschäftspartner",
	cancel: "Abbrechen",
	carrier: "Frachtführer",
	change_password: "Passwort ändern",
	checking_invitation_code_message: "Einladungscode wird überprüft",
	checkout: "Zur Kasse",
	choose_image: "Bild auswählen",
	choose_your_plan: "Wählen Sie Ihren Plan",
	clear: "Löschen",
	clear_basket: "Warenkorb leeren",
	click_to_play_the_video: "Klicken Sie, um das Video abzuspielen",
	close: "Schließen",
	code: "Code",
	commercial: "Kommerziell",
	commercial_partner: "Geschäftspartner",
	commercial_partners: "Geschäftspartner",
	companies: "Unternehmen",
	company: "Unternehmen",
	company_address: "Firmenadresse",
	company_name: "Firmenname",
	company_profile: "Firmenprofil",
	configuration: "Konfiguration",
	confirm: "Bestätigen",
	confirm_distance_selling_agreement: "Bestätigen Sie den Fernabsatzvertrag.",
	consult_us: "Beraten Sie uns",
	contact: "Kontakt",
	contact_info: "Kontaktinformationen",
	contact_text: "Keine Sorge, wir werden uns so schnell wie möglich bei Ihnen melden.",
	contact_title: "Beraten Sie uns, vereinfachen Sie Ihre Prozesse",
	contact_to_us: "Kontaktieren Sie uns",
	container: "Container",
	container_no: "Container-Nr",
	containers: "Container",
	content: "Inhalt",
	contract: "Vertrag",
	copy_link: "Link kopieren",
	corporation: "Unternehmen",
	countries: "Länder",
	country: "Land",
	create: "Erstellen",
	create_a_new_account: "Ein neues Konto erstellen",
	create_company: "Unternehmen erstellen",
	create_document: "Dokument erstellen",
	create_shipment: "Sendung erstellen",
	created_at: "Erstellt am",
	created_here: "Hier erstellt",
	credit_card_info: "Kreditkarteninformationen",
	credit_card_no: "Kreditkartennummer",
	currencies: "Währungen",
	currency: "Währung",
	current_password: "Aktuelles Passwort",
	current_plan: "Aktueller Plan",
	customer_company_address: "Kundenfirmenadresse",
	customer_company_name: "Kundenfirmenname",
	customs: "Zoll",
	customs_agencies: "Zollagenturen",
	customs_agency: "Zollagentur",
	cvv: "CVV",
	daily: "Täglich",
	damaged: "Beschädigt",
	dashboard: "Dashboard",
	date: "Datum",
	date_input: "Datums-Eingabe",
	day: "Tag",
	default: "Standard",
	default_language: "Standardsprache",
	delete: "Löschen",
	delete_account: "Konto löschen",
	delete_confirm_message: "Bestätigen Sie das Löschen?",
	delete_document: "Dokument löschen",
	delete_template: "Vorlage löschen",
	description: "Beschreibung",
	detail: "Detail",
	dimensions: "Abmessungen",
	discard: "Verwerfen",
	discover_all_benefits: "Alle Vorteile entdecken",
	distance_sales_agreement: "Der Fernabsatzvertrag",
	document: "Dokument",
	document_actions: "Dokumentaktionen",
	document_added: "Dokument hinzugefügt",
	document_creator: "Dokumentenersteller",
	document_manager: "Dokumentenmanager",
	document_name: "Dokumentname",
	document_number: "Dokumentnummer",
	document_overwrite: "Bearbeitungen als neues Dokument speichern",
	document_save_info: "Dieses Dokument wird nur in dieser Proforma-Rechnung gespeichert.",
	document_updated: "Dokument aktualisiert",
	download: "Herunterladen",
	download_pdf: "PDF herunterladen",
	download_template: "Vorlage herunterladen",
	edit: "Bearbeiten",
	edit_attribute: "Attribut bearbeiten",
	edit_description: "Beschreibung bearbeiten",
	edit_document: "Dokument aktualisieren",
	edit_item: "{item} bearbeiten",
	edit_packaging: "Verpackung bearbeiten",
	edit_product: "Produkt bearbeiten",
	edit_profile: "Profil bearbeiten",
	edit_stock: "Bestand bearbeiten",
	edit_stock_batch: "Bestandspartie bearbeiten",
	edit_template: "Vorlage aktualisieren",
	edit_variant: "Variante Bearbeiten",
	edit_your_profile_picture: "Bearbeiten Sie Ihr Profilbild",
	email: "E-Mail",
	employee: "Mitarbeiter",
	employee_type: "Mitarbeiterart",
	employees: "Mitarbeiter",
	empty_data_warning:
		"In diesem Bereich gibt es noch keine Daten. Sie können die Plattform mit Beispieldaten erkunden.",
	estimated_arrival_day: "Geschätzter Ankunftstag",
	expense: "Ausgabe",
	expenses: "Ausgaben",
	expires_at: "Läuft ab am",
	explore_pdf_editor: "Dokumente sofort erstellen",
	explore_stock_management: "Beherrschen Sie Ihren Bestand",
	explore_tracking_features: "In Echtzeit verfolgen",
	exported_containers: "Exportierte Container",
	fail: "Fehlschlag",
	failed: "Fehlgeschlagen",
	faq: "F.A.Q.",
	feedback: "Feedback",
	file: "Datei",
	file_name: "Dateiname",
	file_preview: "Dateivorschau",
	file_processing_error_message: "Fehler bei der Verarbeitung der Datei: {error}",
	file_read_error_message: "Fehler beim Lesen der Datei",
	file_view: "Datei anzeigen",
	filter: "Filter",
	first_name: "Vorname",
	first_name_last_name: "Vorname Nachname",
	fixed_value: "Fester Wert",
	forget_password: "Passwort vergessen",
	forget_password_message: "Haben Sie Ihr Passwort vergessen?",
	forget_password_subtitle: "Bitte geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen.",
	format: "Format",
	free: "Kostenlos",
	from: "Von",
	general: "Standard",
	get_started_now: "Jetzt loslegen",
	give_us_feedback: "Geben Sie uns Feedback",
	go_to_panel: "Zum Panel gehen",
	go_to_proforma: "Zur Proforma-Rechnung gehen",
	go_to_shipment: "Zum Versand gehen",
	gross: "Brutto",
	height: "Höhe",
	hide: "Verstecken",
	hide_all: "Alles ausblenden",
	home_page: "Startseite",
	i_have_invitation_code: "Ich habe einen Einladungscode",
	image_delete: "Bild löschen",
	images: "Bilder",
	import_excel: "Aus Excel importieren",
	import_fail_message: "Import fehlgeschlagen: {error}",
	import_success_message: "Erfolgreich {count} Produkte importiert{skipped}.",
	imported_containers: "Importierte Container",
	in_progress: "In Bearbeitung",
	in_stock: "Auf Lager",
	incoming: "Eingehend",
	incoming_shipments: "Eingehende Sendungen",
	initial: "Initial",
	inputs: "Inhalt",
	invitation: "Einladung",
	invitation_code: "Einladungscode",
	invitation_mail_sent: "Einladung per E-Mail gesendet",
	invitations: "Einladungen",
	invoice: "Rechnung",
	invoice_no: "Rechnungsnummer",
	join: "Beitreten",
	join_company: "Unternehmen beitreten",
	language: "Sprache",
	language_options: "Sprachoptionen",
	last_name: "Nachname",
	last_one_year: "Letztes 1 Jahr",
	latitude: "Breitengrad",
	learn_more: "Mehr erfahren",
	left_a_comment: "Hat einen Kommentar hinterlassen",
	length: "Länge",
	link_copied: "Link kopiert",
	link_copy_failed: " Link kopieren fehlgeschlagen",
	loading_country: "Lade-Land",
	loading_point: "Ladepunkt",
	loading_port: "Ladehafen",
	log_in: "einloggen",
	logo: "Logo",
	longitude: "Längengrad",
	lot_no: "Losnummer",
	mail_sent: "E-Mail gesendet",
	make_visible: "Sichtbar machen",
	manage_profile: "Profil verwalten",
	mass: "Masse",
	measurements: "Maße",
	merge_partner_description:
		"Das hier erstellte Unternehmen kann mit dem bestehenden verifizierten Partner zusammengeführt werden, wenn es ein Profil bei Antrego erstellt.",
	message: "Nachricht",
	message_company_create: "Unternehmen erstellt.",
	message_company_join: "Bitte geben Sie den Einladungscode ein.",
	message_company_joined: "Sie sind dem Unternehmen beigetreten",
	message_employee_delete: "Mitarbeiter gelöscht.",
	message_employee_save: "Mitarbeiter gespeichert.",
	message_join_company: "Geben Sie Ihren Code ein, um einem bestehenden Unternehmen beizutreten",
	method: "Methode",
	migrate: "Migrieren",
	migrate_partner: "Partner migrieren",
	migrate_partner_description:
		"Das hier erstellte Unternehmen kann mit dem bestehenden verifizierten Partner zusammengeführt werden, wenn dieser ein Profil auf Antrego erstellt.",
	missing_product_group_sheet_message: "Fehlendes Produktgruppenblatt in der Excel-Datei",
	missing_product_sheet_message: "Fehlendes Produktblatt in der Excel-Datei",
	mobile_number: "Mobilnummer",
	month: "Monat",
	month_lowercase: "monat",
	monthly: "Monatlich",
	multiple_select: "Mehrfachauswahl",
	my_profile: "mein Profil",
	my_role: "Meine Rolle",
	name: "Name",
	net: "Netto",
	new: "Neu",
	new_company_package: "kostenlos",
	new_password: "Neues Passwort",
	new_shipment: "Neue Sendung",
	next: "Weiter",
	no: "Nein",
	no_content: "Kein Inhalt",
	no_entity: "Kein {entityName} vorhanden",
	no_entity_message: "Erstellen Sie {entityName}, und seine Details werden hier angezeigt.",
	no_image: "Kein Bild gefunden",
	no_product_data_message: "Keine Produktdaten in der Excel-Datei gefunden",
	no_product_group_data_message: "Keine Produktgruppendaten in der Excel-Datei gefunden",
	no_stock_batches_found: "Keine Lagercharge gefunden",
	no_stock_matches_filters: "Es gibt keinen Lagerbestand, der den ausgewählten Filtern entspricht.",
	no_stocks_added_yet: "Es wurde noch kein Lagerbestand hinzugefügt — bitte wählen oder fügen Sie einen hinzu.",
	no_text: "Kein Text",
	no_valid_products_message:
		"Keine gültigen Produkte gefunden. Alle Produkte müssen einen Namen in der Standardsprache ({language}) haben.",
	not_found_in_stock: "Kein Produkt mit aktuellen Filtern im Lager gefunden.",
	not_found_page_message: "Entschuldigung, ich konnte diese Seite nicht finden :(",
	not_set: "Nicht gesetzt",
	note: "Notiz",
	notes: "Notizen",
	number_of_rows: "Zeilenanzahl",
	ok: "OK",
	operation_fail: "Vorgang fehlgeschlagen",
	option: "Option",
	options: "Optionen",
	other: "Andere",
	out_of_stock: "Nicht Auf Lager",
	outgoing: "Ausgehend",
	outgoing_shipments: "Ausgehende Sendungen",
	packages: "Pakete",
	packaging: "Verpackung",
	packing_list_title: "Packliste",
	parent_group: "Übergeordnete Gruppe",
	partner: "Partner",
	partners: "Partner",
	partnership_status: "Partnerschaftsstatus",
	passive: "Passiv",
	password: "Passwort",
	pay: "Bezahlen",
	payback: "Rückzahlung",
	payback_confirm_message: "Bestätigen Sie die Rückzahlung?",
	payback_warning_message: "Wenn Sie fortfahren, wird Ihr Abonnement beendet.",
	payment: "Zahlung",
	payment_amount: "Zahlungsbetrag",
	payment_awaited: "Zahlung erwartet",
	payment_history: "Zahlungsverlauf",
	payment_info: "Zahlungsinformationen",
	payment_information: "Zahlungsinformationen",
	payment_success: "Zahlung erfolgreich",
	payment_summary: "Zahlungsübersicht",
	payment_will_be_made_3d_secure: "*Ihre Zahlung wird mit 3D Secure durchgeführt.",
	pdf_attached_message: "PDF erfolgreich angehängt",
	pdf_editor: "PDF-Editor",
	pdf_name: "PDF-Name",
	pending_invitations: "Ausstehende Einladungen",
	per_month: "pro Monat",
	phone_number: "Telefonnummer",
	pieces: "Stücke",
	plate_numbers: "Kennzeichen",
	please_click_add_option:
		"Sie haben eine Option eingegeben, aber nicht hinzugefügt. Bitte fügen Sie sie hinzu oder löschen Sie sie.",
	prefix: "Präfix",
	premium: "Premium",
	premium_plus: "Premium Plus",
	preview: "Vorschau",
	previous: "Zurück",
	price: "Preis",
	pricing: "Preise",
	process: "Prozess",
	product: "Produkt",
	product_details: "Produktdetails",
	product_group: "Produktgruppe",
	product_group_name: "Name der Produktgruppe",
	product_group_not_found_message:
		'Produktgruppe "{group}" nicht gefunden. Produkt mit Code "{code}" wird übersprungen.',
	product_groups: "Produktgruppen",
	product_images: "Produktbilder",
	product_name: "Produktname",
	products: "Produkte",
	profile: "Profil",
	proforma_invoice: "Proforma-Rechnung",
	proforma_invoices: "Proforma-Rechnungen",
	proforma_number: "Proforma-Nummer",
	proforma_options: "Proforma-Optionen",
	proforma_title: "Proformarechnung",
	purchase: "Kauf",
	quantity: "Menge",
	quantity_warning:
		"Da Sie den Gesamtwert des Bestands bereits geändert haben, wird die Gesamtsumme nicht mehr automatisch berechnet.",
	ready_to_import: "Bereit zum Importieren",
	receiver: "Empfänger",
	receiver_company: "Empfängerfirma",
	receiver_customs_agency: "Empfänger-Zollagentur",
	redirection_to_home_link: "Startseite",
	redirection_to_home_message: "Sie können auch zu ",
	redirection_to_sign_in_message: "Haben Sie ein Konto?",
	redirection_to_sign_up_message: "Haben Sie noch kein Konto?",
	reload: "Neu laden",
	renewal: "Erneuerung",
	repaid: "Zurückgezahlt",
	reserved: "Reserviert",
	reset_password: "Passwort zurücksetzen",
	returned: "Zurückgegeben",
	route: "Route",
	rows_per_page: "Zeilen pro Seite",
	sales: "Verkäufe",
	save: "Speichern",
	save_as_document: "Als Dokument speichern",
	save_as_new_document: "Als neues Dokument speichern",
	save_as_new_template: "Als neue Vorlage speichern",
	save_as_template: "Als Vorlage speichern",
	save_changes: "Änderungen speichern",
	save_pdf_to_attachments: "PDF in Anhänge speichern",
	saved_card_info: "Gespeicherte Karteninformationen",
	search: "Suchen",
	select: "Auswählen",
	select_a_file_to_preview: "Datei zur Vorschau auswählen",
	select_document: "Dokument auswählen",
	select_document_to_overwrite: "Dokument zum Überschreiben auswählen",
	select_file: "Datei auswählen",
	select_file_place_holder: "Bitte wählen Sie ein Bild aus",
	select_language: "Sprache auswählen",
	select_template: "Vorlage auswählen",
	select_template_to_overwrite: "Vorlage zum Überschreiben auswählen",
	selected: "Ausgewählt",
	selected_partner: "Ausgewählter Partner",
	send: "Senden",
	send_again: "Erneut senden",
	send_email: "E-Mail senden",
	send_feedback: "Feedback senden",
	send_invitation: "Einladung senden",
	sender: "Absender",
	sender_company: "Absenderfirma",
	sender_customs_agency: "Absender-Zollagentur",
	separate_gross: "Bruttomaße hinzufügen",
	settings: "Einstellungen",
	shipment: "Sendung",
	shipment_code: "Versandcode",
	shipment_details: "Versanddetails",
	shipment_method: "Versandmethode",
	shipment_type: "Sendungstyp",
	shipments: "Sendungen",
	shipments_filter: "Sendungsfilter",
	shipped: "Versandt",
	shipping_term: "Versandbedingungen",
	shipping_terms: "Versandbedingungen",
	show: "Anzeigen",
	show_all: "Alles anzeigen",
	show_company_stock_page: "Firmenseitenbestand anzeigen",
	show_in_stocks: "Auf der Lagerseite anzeigen",
	sign_in: "Anmelden",
	sign_out: "Abmelden",
	sign_out_confirm_message: "Bestätigen Sie das Abmelden?",
	sign_out_success_message: "Auf Wiedersehen.",
	sign_up: "Registrieren",
	sizes: "Größen",
	social_media: "Soziale Medien",
	social_media_account: "Sozialmedia-Konto",
	start_time: "Startzeit",
	status: "Status",
	stock: "Bestand",
	stock_details: "Bestandsdetails",
	stock_images: "Bestandsbilder",
	stock_status: "Bestandsstatus",
	stocks: "Bestände",
	stocks_url: "Lagerlink",
	subscribe: "Abonnieren",
	subscription: "Abonnement",
	subscription_info_message:
		"Sie können während der Abonnementlaufzeit uneingeschränkt von allen Diensten profitieren.",
	subscription_warning_message:
		"**Ihre Kartendaten werden sicher gespeichert und Ihr Abonnement wird regelmäßig erneuert, es sei denn, Sie kündigen es.",
	success: "Erfolg",
	super: "Super",
	supported_files_img: "Unterstützte Dateitypen: JPG, PNG-Dateien unter 20 MB",
	switch_language: "Sprache wechseln",
	switch_theme: "Thema wechseln",
	table_inputs: "Tabelleninhalt",
	target: "Ziel",
	target_partner: "Zielpartner",
	tax_number: "Steuernummer",
	template: "Vorlage",
	template_actions: "Vorlagenaktionen",
	template_added: "Vorlage hinzugefügt",
	template_name: "Vorlagenname",
	template_overwrite: "Bearbeitungen als neue Vorlage speichern",
	template_save_info: "Gespeicherte Vorlagen werden später für Proforma-Rechnungen und Sendungen verfügbar sein.",
	template_updated: "Vorlage aktualisiert",
	terms_of_sale_and_other_comments: "Verkaufsbedingungen - Kommentare",
	text_input: "Texteingabe",
	theme: "Thema",
	this_month: "Dieser Monat",
	this_year: "Dieses Jahr",
	title: "Titel",
	to: "An",
	toDelete: "Löschen",
	total: "Gesamt",
	total_amount: "Gesamtbetrag",
	total_price: "Gesamtpreis",
	total_warning: "Wenn Sie diese Daten ändern, wird die Gesamtsumme nicht mehr automatisch berechnet.",
	tracking: "Sendungsverfolgung",
	transaction_no: "Transaktionsnummer",
	transactions: "Transaktionen",
	try_for_free: "kostenlos ausprobieren",
	type: "Typ",
	types: "Typen",
	un_archive: "Wiederherstellen",
	unit: "Einheit",
	unit_price: "Stückpreis",
	units: "Einheiten",
	unloading_country: "Entlade-Land",
	unloading_point: "Entladepunkt",
	unloading_port: "Entladehafen",
	unsubscribe: "Abbestellen",
	unsubscribe_confirm_message:
		"Wenn Sie das Abonnement kündigen, können Sie die Systemfunktionen nicht mehr effektiv nutzen. Sind Sie sicher, dass Sie das Abonnement kündigen möchten?",
	upload_new_image: "Neues Bild hochladen",
	use_code: "Code verwenden",
	use_invitation_code: "Einladungscode verwenden",
	use_invitation_code_description: "Geben Sie Ihren Einladungscode ein, der an Ihre Mailbox gesendet wurde.",
	use_invitation_code_success_message: "Der Einladungscode wurde erfolgreich verwendet.",
	user_profile: "Mein Profil",
	value: "Wert",
	variant: "Variante",
	variants: "Varianten",
	vehicle: "Fahrzeug",
	vehicles: "Fahrzeuge",
	verified_partner: "Verifizierter Partner",
	verify_password: "Passwort bestätigen",
	visibility: "Sichtbarkeit",
	warehouse: "Lager",
	warehouses: "Lagerhäuser",
	warn_unsaved_measurement: "Vergiss nicht, auf '+' zu klicken, um deine Maße hinzuzufügen.",
	website: "Webseite",
	week: "Woche",
	weight: "Gewicht",
	weight_kg: "Gewicht (kg)",
	welcome: "Willkommen",
	what_we_are_doing: "Was wir tun",
	width: "Breite",
	year: "Jahr",
	year_lowercase: "jahr",
	yearly: "Jährlich",
	yes: "Ja",
	yes_no: "Ja / Nein",
	you_dont_have_any_active_subscription: "Sie haben kein aktives Abonnement.",
};
